import { ChartType } from '@constants/constants';
import { Box } from '@mui/material';
import BarChartSkeleton from '../../../../../../../components/Charts/BarChart/BarChartSkelton';
import { FC } from 'react';

interface ChartLoadingProps {
  chartType: ChartType;
}

export const ChartLoading: FC<ChartLoadingProps> = ({ chartType }) => {
  if (chartType === ChartType.TABLE) {
    return <Box>Loading</Box>;
  }

  return <BarChartSkeleton />;
};
